import { motion } from "framer-motion";
import { Route, Plane, MessageCircle, UtensilsCrossed } from "lucide-react";
import { SERVICIOS } from "./data";
import { Reveal, Overline } from "./Reveal";

const ICONS = [Route, Plane, MessageCircle, UtensilsCrossed];
const STYLES = [
  "lg:col-span-7 bg-selva text-arena",
  "lg:col-span-5 bg-sol text-selva",
  "lg:col-span-5 bg-mar text-arena",
  "lg:col-span-7 bg-white text-selva",
];

const Card = ({ s, i }) => {
  const Icon = ICONS[i];
  const withImg = i === 0 || i === 3;
  return (
    <motion.article data-testid={`service-card-${i + 1}`}
      initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay: (i % 2) * 0.12, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ y: -6 }}
      className={`group relative flex min-h-[340px] flex-col justify-between overflow-hidden rounded-[2rem] p-8 sm:p-10 ${STYLES[i]}`}>
      {withImg && (
        <div className="absolute inset-y-0 right-0 hidden w-[42%] overflow-hidden sm:block [clip-path:inset(0_0_0_0_round_2rem)]">
          <img src={i === 0 ? "/img/palm.jpg" : "/img/beach.jpg"} alt="" className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-110" />
        </div>
      )}
      <div className={`relative flex items-start justify-between ${withImg ? "sm:w-[52%]" : ""}`}>
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl border border-current bg-white/10 transition-transform duration-500 group-hover:rotate-12">
          <Icon className="h-6 w-6" />
        </span>
        <span className="font-serif-i text-4xl opacity-60">{s.n}</span>
      </div>
      <div className={`relative ${withImg ? "sm:w-[52%]" : ""}`}>
        <h3 className="font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl">{s.title}</h3>
        <p className="mt-4 text-base leading-relaxed opacity-85">{s.text}</p>
      </div>
    </motion.article>
  );
};

export const Services = () => (
  <section id="servicios" data-testid="services-section" className="relative bg-arena py-24 lg:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
      <div className="mb-14 grid gap-8 lg:mb-20 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <Overline>Servicios</Overline>
          <h2 className="font-display text-4xl font-extrabold leading-[0.95] tracking-tight text-selva sm:text-6xl">
            Tú eliges el sueño. <span className="font-serif-i font-normal text-barro">Nosotros</span> el camino.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="self-end lg:col-span-4 lg:col-start-9">
          <p className="text-base leading-relaxed text-tinta/75 md:text-lg">
            Un solo equipo se ocupa de todo tu viaje, para que tú solo pienses en la caipirinha de bienvenida.
          </p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-12 lg:gap-6">
        {SERVICIOS.map((s, i) => <Card key={s.n} s={s} i={i} />)}
      </div>
    </div>
  </section>
);
